import React from "react";
import { graphql } from "gatsby";
import { CreditCardCalculator as CreditCardCalculatorComponent } from "@zempler/theme/src/components/creditCardCalulator/CreditCardCalculator";

export const CreditCardCalculator = ({ data, ...rest }) => (
  <CreditCardCalculatorComponent {...data} />
);

export const CreditCardCalculatorQuery = graphql`
  fragment CreditCardCalculator on UMBRACO_CreditCardCalculatorComponentType {
    heading
    subHeading
    smallPrintText
    backgroundColour
    additionalLinksHeading
    additionalLinks {
      ...Link
    }
  }
`;
